import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Table } from 'semantic-ui-react';

const SpreadsheetPreviewModal = ({ open, onClose, data }) => (
  <Modal open={open} onClose={onClose} size="small">
    <Modal.Content
      scrolling
      style={{ marginTop: '30px', paddingTop: '0px' }}
    >
      {data.rows.length > 0 ? (
        <Table basic="very" size="small">
          <Table.Header>
            <Table.Row>
              {data.columns.map(col => (
                <Table.HeaderCell
                  key={col}
                  style={{
                    position: 'sticky',
                    top: 0,
                    background: '#fff',
                    zIndex: 1,
                  }}
                >
                  {col}
                </Table.HeaderCell>
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data.rows.map((row, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Table.Row key={i}>
                {data.columns.map(col => (
                  <Table.Cell key={col}>{row[col]}</Table.Cell>
                ))}
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      ) : (
        <p>No data found in file.</p>
      )}
    </Modal.Content>
  </Modal>
);

SpreadsheetPreviewModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.string),
    rows: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  }),
};

SpreadsheetPreviewModal.defaultProps = {
  data: { columns: [], rows: [] },
};

export default SpreadsheetPreviewModal;
